export const CONTACT_US = "CONTACT_US";
export const CONTACT_US_SUCCESS = "CONTACT_US_SUCCESS";
export const CONTACT_US_ERROR = "CONTACT_US_ERROR";
export const CLEAR_CONTACT_US_FLAG = "CLEAR_CONTACT_US_FLAG";
